/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Col,
  Divider,
  Empty,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Modal,
  Tooltip,
} from 'antd';

import { DeleteOutlined } from '@ant-design/icons';

import Utils from '../../../Assets/Scripts/Utils';
import { api } from '../../../Services/axiosService';

function EmailSettings({ fieldsPermissions, emailBlacklist, fetchData }) {
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [loading, setLoading] = useState(false);

  const hasEmailPermissions =
    fieldsPermissions?.Email?.access !== 0 ||
    fieldsPermissions?.EmailPassword?.access !== 0 ||
    fieldsPermissions?.EmailHost?.access !== 0 ||
    fieldsPermissions?.EmailPort?.access !== 0 ||
    fieldsPermissions?.ImapEmailHost?.access !== 0 ||
    fieldsPermissions?.ImapEmailPort?.access !== 0 ||
    fieldsPermissions?.EmailBlacklist?.access !== 0;

  const handleDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`/Settings/EmailBlacklist/${selectedEmail}`);
      message.success('E-mail removido da lista negra com sucesso!');
      fetchData();
    } catch (error) {
      Utils.logError(error);
      message.error(
        Utils.getErrorMessage(error, 'Oops. Algo deu errado ao tentar remover o e-mail!')
      );
    } finally {
      setLoading(false);
      setIsModalDeleteOpen(false);
      setSelectedEmail(null);
    }
  };

  if (!hasEmailPermissions)
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de e-mail disponível" />
      </div>
    );

  return (
    <>
      <Col span={24}>
        <Divider className="configuration-divider" orientation="left">
          E-mail Remetente
        </Divider>
      </Col>

      {fieldsPermissions?.EmailHost?.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="E-mail SMTP"
            name="emailHost"
            rules={[
              {
                required: fieldsPermissions?.EmailHost?.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.EmailHost?.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.EmailPort?.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Porta SMTP"
            name="emailPort"
            rules={[
              {
                required: fieldsPermissions?.EmailPort?.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              min={0}
              max={9999}
              placeholder="0"
              disabled={fieldsPermissions?.EmailPort?.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.ImapEmailHost?.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="E-mail IMAP"
            name="imapEmailHost"
            rules={[
              {
                required: fieldsPermissions?.ImapEmailHost?.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.ImapEmailHost?.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.ImapEmailPort?.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Porta IMAP"
            name="imapEmailPort"
            rules={[
              {
                required: fieldsPermissions?.ImapEmailPort?.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              min={0}
              max={9999}
              placeholder="0"
              disabled={fieldsPermissions?.ImapEmailPort?.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.Email?.access !== 0 && (
        <Col span={6}>
          <Form.Item label="id" name="id" className="input-hidden" initialValue={1}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: fieldsPermissions?.Email?.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              placeholder="exemplo@email.com"
              disabled={fieldsPermissions?.Email?.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.EmailPassword?.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Senha"
            name="emailPassword"
            rules={[
              {
                required: fieldsPermissions?.EmailPassword?.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input.Password disabled={fieldsPermissions?.EmailPassword?.access !== 2} />
          </Form.Item>
        </Col>
      )}

      <Col span={24}>
        <Divider className="configuration-divider" orientation="left">
          E-mails Auxiliares
        </Divider>
      </Col>

      <Col span={8}>
        <Form.Item
          label="Email Pessoal"
          name="emailPerson"
          rules={[
            {
              validator: Utils.validateEmails,
            },
          ]}
        >
          <Input placeholder="exemplo@email.com; exemplo2@email.com" />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item
          label="Email do Time"
          name="emailTeam"
          rules={[
            {
              validator: Utils.validateEmails,
            },
          ]}
        >
          <Input placeholder="exemplo@email.com; exemplo2@email.com" />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item
          label="E-mail de monitoramento"
          name="monitoringEmail"
          rules={[
            {
              validator: Utils.validateEmails,
            },
          ]}
        >
          <Input placeholder="exemplo@email.com; exemplo2@email.com" />
        </Form.Item>
      </Col>

      {fieldsPermissions?.EmailBlacklist?.access !== 0 && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              Lista Negra de Destinatários
            </Divider>
          </Col>

          <Col span={6}>
            <List
              dataSource={emailBlacklist}
              renderItem={(email) => (
                <List.Item
                  actions={[
                    <Tooltip title="Excluir e-mail da lista" key={`delete-${email}`}>
                      <Button
                        danger
                        type="text"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          setSelectedEmail(email);
                          setIsModalDeleteOpen(true);
                        }}
                      />
                    </Tooltip>,
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                        {email}
                      </span>
                    }
                  />
                </List.Item>
              )}
              locale={{ emptyText: 'Nenhum e-mail na lista negra' }}
            />
          </Col>
          <Modal
            title="Confirmar exclusão"
            open={isModalDeleteOpen}
            onOk={handleDelete}
            onCancel={() => setIsModalDeleteOpen(false)}
            okText="Excluir"
            closable={false}
            width="fit-content"
            confirmLoading={loading}
            okButtonProps={{
              style: {
                backgroundColor: '#d9534f',
                color: 'white',
                border: 'none',
              },
            }}
          >
            <h4>
              Deseja realmente <strong style={{ color: '#d9534f' }}>excluir</strong> este registro?
            </h4>
          </Modal>
        </>
      )}
    </>
  );
}

export default EmailSettings;
